import { FunctionComponent, ReactNode } from 'react'
import { useScreenSize } from './screenSizeContext'

interface MobileProps {
    children: ReactNode
}

const Mobile: FunctionComponent<MobileProps> = ({ children }: MobileProps) => {
    const isMobile: boolean = useScreenSize()
    return isMobile ? <>{children}</> : null
}

export default Mobile
